// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loan-requests-table-wrapper {
  overflow-x: auto !important;
  overflow-y: visible !important;
  width: 100% !important;
}

.loan-requests-table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.loan-requests-table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.loan-requests-table-wrapper::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.loan-requests-table-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.loan-requests-table {
  min-width: 1100px !important;
  width: 100% !important;
  table-layout: fixed !important;
}

.loan-requests-table th:nth-child(1),
.loan-requests-table td:nth-child(1) {
  width: 160px !important;
  min-width: 160px !important;
  max-width: 160px !important;
}

.loan-requests-table th:nth-child(2),
.loan-requests-table td:nth-child(2) {
  width: 130px !important;
  min-width: 130px !important;
  max-width: 130px !important;
}

.loan-requests-table th:nth-child(3),
.loan-requests-table td:nth-child(3) {
  width: 220px !important;
  min-width: 220px !important;
  max-width: 220px !important;
  white-space: normal !important;
  word-wrap: break-word !important;
}

.loan-requests-table th:nth-child(4),
.loan-requests-table td:nth-child(4) {
  width: 80px !important;
  min-width: 80px !important;
  max-width: 80px !important;
}

.loan-requests-table th:nth-child(5),
.loan-requests-table td:nth-child(5) {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

.loan-requests-table th:nth-child(6),
.loan-requests-table td:nth-child(6) {
  width: 140px !important;
  min-width: 140px !important;
  max-width: 140px !important;
}

.loan-requests-table th:nth-child(7),
.loan-requests-table td:nth-child(7) {
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
}

.loan-requests-table th:nth-child(8),
.loan-requests-table td:nth-child(8) {
  width: 120px !important;
  min-width: 120px !important;
  max-width: 120px !important;
}

.loan-requests-table th:nth-child(9),
.loan-requests-table td:nth-child(9) {
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}

.loan-requests-table th:nth-child(10),
.loan-requests-table td:nth-child(10) {
  width: 130px !important;
  min-width: 130px !important;
  max-width: 130px !important;
}

.loan-requests-table td {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.loan-requests-table td:nth-child(3) {
  white-space: normal !important;
  word-wrap: break-word !important;
  overflow: visible !important;
  text-overflow: initial !important;
}

.loan-requests-table td:nth-child(7),
.loan-requests-table td:nth-child(8),
.loan-requests-table td:nth-child(9),
.loan-requests-table td:nth-child(10) {
  white-space: normal !important;
  overflow: visible !important;
}

.loan-requests-table td:nth-child(7) .d-flex,
.loan-requests-table td:nth-child(8) .d-flex,
.loan-requests-table td:nth-child(9) .d-flex,
.loan-requests-table td:nth-child(10) .d-flex {
  justify-content: center !important;
  flex-wrap: nowrap !important;
}

.loan-requests-table td:nth-child(7) .btn,
.loan-requests-table td:nth-child(8) .btn,
.loan-requests-table td:nth-child(9) .btn,
.loan-requests-table td:nth-child(10) .btn {
  white-space: nowrap !important;
  font-size: 11px !important;
  padding: 0.25rem 0.6rem !important;
  flex-shrink: 0 !important;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/LoanRequests/LoanRequestsTable.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;EAEE,sBAAsB;EACtB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;;;;EAIE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;;;;EAIE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;;;;EAIE,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,yBAAyB;AAC3B","sourcesContent":[".loan-requests-table-wrapper {\n  overflow-x: auto !important;\n  overflow-y: visible !important;\n  width: 100% !important;\n}\n\n.loan-requests-table-wrapper::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.loan-requests-table-wrapper::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.loan-requests-table-wrapper::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.loan-requests-table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.loan-requests-table {\n  min-width: 1100px !important;\n  width: 100% !important;\n  table-layout: fixed !important;\n}\n\n.loan-requests-table th:nth-child(1),\n.loan-requests-table td:nth-child(1) {\n  width: 160px !important;\n  min-width: 160px !important;\n  max-width: 160px !important;\n}\n\n.loan-requests-table th:nth-child(2),\n.loan-requests-table td:nth-child(2) {\n  width: 130px !important;\n  min-width: 130px !important;\n  max-width: 130px !important;\n}\n\n.loan-requests-table th:nth-child(3),\n.loan-requests-table td:nth-child(3) {\n  width: 220px !important;\n  min-width: 220px !important;\n  max-width: 220px !important;\n  white-space: normal !important;\n  word-wrap: break-word !important;\n}\n\n.loan-requests-table th:nth-child(4),\n.loan-requests-table td:nth-child(4) {\n  width: 80px !important;\n  min-width: 80px !important;\n  max-width: 80px !important;\n}\n\n.loan-requests-table th:nth-child(5),\n.loan-requests-table td:nth-child(5) {\n  width: 100px !important;\n  min-width: 100px !important;\n  max-width: 100px !important;\n}\n\n.loan-requests-table th:nth-child(6),\n.loan-requests-table td:nth-child(6) {\n  width: 140px !important;\n  min-width: 140px !important;\n  max-width: 140px !important;\n}\n\n.loan-requests-table th:nth-child(7),\n.loan-requests-table td:nth-child(7) {\n  width: 120px !important;\n  min-width: 120px !important;\n  max-width: 120px !important;\n}\n\n.loan-requests-table th:nth-child(8),\n.loan-requests-table td:nth-child(8) {\n  width: 120px !important;\n  min-width: 120px !important;\n  max-width: 120px !important;\n}\n\n.loan-requests-table th:nth-child(9),\n.loan-requests-table td:nth-child(9) {\n  width: 100px !important;\n  min-width: 100px !important;\n  max-width: 100px !important;\n}\n\n.loan-requests-table th:nth-child(10),\n.loan-requests-table td:nth-child(10) {\n  width: 130px !important;\n  min-width: 130px !important;\n  max-width: 130px !important;\n}\n\n.loan-requests-table td {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n.loan-requests-table td:nth-child(3) {\n  white-space: normal !important;\n  word-wrap: break-word !important;\n  overflow: visible !important;\n  text-overflow: initial !important;\n}\n\n.loan-requests-table td:nth-child(7),\n.loan-requests-table td:nth-child(8),\n.loan-requests-table td:nth-child(9),\n.loan-requests-table td:nth-child(10) {\n  white-space: normal !important;\n  overflow: visible !important;\n}\n\n.loan-requests-table td:nth-child(7) .d-flex,\n.loan-requests-table td:nth-child(8) .d-flex,\n.loan-requests-table td:nth-child(9) .d-flex,\n.loan-requests-table td:nth-child(10) .d-flex {\n  justify-content: center !important;\n  flex-wrap: nowrap !important;\n}\n\n.loan-requests-table td:nth-child(7) .btn,\n.loan-requests-table td:nth-child(8) .btn,\n.loan-requests-table td:nth-child(9) .btn,\n.loan-requests-table td:nth-child(10) .btn {\n  white-space: nowrap !important;\n  font-size: 11px !important;\n  padding: 0.25rem 0.6rem !important;\n  flex-shrink: 0 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
